module.exports = __webpack_public_path__ + "graphics/basket-arrow.ckh.6f4c39e3ad16b53c4be8b338e3c81c7f.svg";